module.exports = __webpack_public_path__ + "static/media/3-gruppovye.a2abf0cf.jpg";